import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import { token } from "functions/Helper";
import CreateAgentBookingPromoCode from "views/AgentBookingPromoCodes/Create";
import DeleteAgentBookingPromoCodes from "views/AgentBookingPromoCodes/Delete";
import EditAgentBookingPromoCode from "views/AgentBookingPromoCodes/Edit";
import AgentBookingPromoCodesList from "views/AgentBookingPromoCodes/List";
import ViewAgentBookingPromoCodes from "views/AgentBookingPromoCodes/View";

const agentBookingPromoCode = () => {
  let views = [];

  if (
    token["booking.agent_booking_promo_codes.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/AgentBookingPromoCodeList",
      name: "Agent Booking Promo Code",
      icon: MonetizationOnIcon,
      component: AgentBookingPromoCodesList,
      layout: "/admin"
    });
  }

  return views;
};

const agentBookingPromoCodeHidden = () => {
  let views = [];

  if (
    token["booking.agent_booking_promo_codes.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/AgentBookingPromoCodes/Create",
        name: "Create Agent Booking Promo Codes",
        component: CreateAgentBookingPromoCode,
        layout: "/admin"
      },
      {
        path: "/AgentBookingPromoCodes/Edit",
        name: "Edit Agent Booking Promo Codes",
        component: EditAgentBookingPromoCode,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/AgentBookingPromoCodes/Delete",
        name: "Delete Agent Booking Promo Codes",
        component: DeleteAgentBookingPromoCodes,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  }

  if (
    token["booking.agent_booking_promo_codes.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/AgentBookingPromoCodes/View",
      name: "View Agent Booking Promo Codes",
      component: ViewAgentBookingPromoCodes,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }
  return [
    {
      collapse: true,
      name: "Agent Booking Promo Code Hidden",
      state: "agentBookingPromoCodeHidden",
      hideInSidebar: true,
      views: views
    }
  ];
};

export { agentBookingPromoCode, agentBookingPromoCodeHidden };
